import React, { useState } from "react";

import Container from "@material-ui/core/Container";
import ApplicationPanel from "../application/ApplicationPanel";
import ApplicationHeader from "../application/ApplicationHeader";
import AuthenticationBrowse from "./AuthenticationBrowse";
import { useAdminAuthentication } from "./authenticationService";
import { notBlank } from "../util/ext";
import { useLocation } from "react-router-dom";

const ManageAuthenticationView = () => {
  const { state = {} } = useLocation();
  const initialSearchState = {
    appliedFilter: null,
    appliedOrganization: state.organizationId,
    orderBy: "organizationName",
    orderDirection: "asc",
    appliedTypes: [],
    page: 0,
  };

  const [searchState, setSearchState] = useState(initialSearchState);
  const searchResults = useAdminAuthentication(
    searchState.appliedFilter,
    searchState.appliedTypes,
    searchState.appliedOrganization,
    notBlank(searchState.orderBy)
      ? `${searchState.orderBy}:${searchState.orderDirection}`
      : null,
    searchState.page,
  );

  return (
    <Container id="manage-authentication" disableGutters>
      <ApplicationHeader />

      <ApplicationPanel>
        <AuthenticationBrowse
          searchState={searchState}
          onSearchStateChange={state => setSearchState(state)}
          searchResults={searchResults}
        />
      </ApplicationPanel>
    </Container>
  );
};

export default ManageAuthenticationView;
